
import { Component, Vue, Watch } from "vue-property-decorator";
import vHeader from "@/views/框架/头部/Index.vue";
import vSidebar from "@/views/框架/导航/Index.vue";
import vTags from "@/views/框架/标签/Index.vue";
import nyNetwork from "@/api/nyBaseNetwork";
import nyMessageToast from "@/utils/NYMessageToast";
@Component({
  components: {
    vHeader,
    vSidebar,
    vTags
  },
})
export default class HomeLayout extends Vue {

  main_height = document.body.offsetHeight - 70;

  mounted() {
  }

  showDialog() {
  }

}
